import styled, { css } from 'styled-components';
import { quinary, white } from '~/components/mixins/color';

export const Row = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
`;


export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100%);
    width: ${(props) => (props.showForm ? 'calc(75%)' : 'calc(100%)')};
    padding: 0px;
    ::-webkit-scrollbar {
      display: none;
    }
  }

  .right {
    display: ${(props) => (props.showForm ? 'flex' : 'none')};
    flex-direction: column;
    position: relative;
    flex: 0 0 25%;
    background: ${white.hex()};
    width: 100%;
    padding: 10px 10px 0 10px;
    margin-left: 10px;
    border-radius: 3px;
    justify-content: space-between;
  }

  ${(props) =>
    props.showForm &&
    css`
      @media (max-width: 1024px) {
        .left {
          display: none;
          visibility: hidden;
        }
        .right {
          flex: 1;
          margin-left: 0px;
        }
      }
      @media (min-width: 769px) and (max-width: 1024px) {
        .right {
          flex: 0 0 45%;
        }
      }
    `}
`;

export const FormToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  height: 56px;
  border-top: 1px solid ${quinary.hex()};

  .buttons {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
  }
`;